import { BackToPublicationAction, BackToPublicationActionKeys } from './actions';

interface BackToPublicationState {
	publicationId: number | undefined;
	page: number | undefined;
}

const initialState: BackToPublicationState = {
	publicationId: undefined,
	page: undefined,
};

function backToPublication(state: BackToPublicationState = initialState, action: BackToPublicationAction): BackToPublicationState {
	switch (action.type) {
		case BackToPublicationActionKeys.SET_LAST_PUBLICATION:
			return {
				...state,
				publicationId: action.publicationId,
				page: action.page,
			};
		default:
			return state;
	}
}

export {
	BackToPublicationState,
	backToPublication,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/BackToPublication/reducer.ts